webpackJsonp([54899801262779],{

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Hyperstate_WebIllustration.4b6d5e1e.png";

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDcxLjYgNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDcxLjYgNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojNDRFNDlCO3N0cm9rZS13aWR0aDozO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDojMUE2MUYzO30KCS5zdDJ7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGcgaWQ9IkxheWVyXzEiPgoJPGcgaWQ9IkxheWVyXzFfMV8iPgoJPC9nPgoJPGcgaWQ9IkxheWVyXzMiPgoJPC9nPgo8L2c+CjxnIGlkPSJMYXllcl8zXzFfIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIzNS4zIiBjeT0iMzYuOSIgcj0iMjMuNCIvPgoJPHJlY3QgeD0iMjkuMyIgeT0iNTEuNiIgY2xhc3M9InN0MSIgd2lkdGg9IjEyLjIiIGhlaWdodD0iMTIuNSIvPgoJPGc+CgkJPHBhdGggY2xhc3M9InN0MiIgZD0iTTM2LjgsNDUuOHYyLjZoLTIuN3YtMi42Yy0yLjEtMC4zLTQtMS4zLTUuMi0yLjhsMi0xLjdjMS4zLDEuNCwyLjgsMi4xLDQuNSwyLjFjMi41LDAsMy43LTAuOCwzLjctMi40CgkJCWMwLTEuNC0xLTItNC0yLjljLTMuOC0xLjEtNS42LTIuMS01LjYtNS4xYzAtMi42LDItNC4zLDQuNi00Ljd2LTIuNmgyLjd2Mi42YzEuOCwwLjMsMy4yLDEuMSw0LjUsMi4zbC0xLjksMS45CgkJCWMtMS4yLTEuMS0yLjMtMS44LTQuMi0xLjhjLTIuMSwwLTMsMC44LTMsMmMwLDEuMiwwLjcsMS44LDMuOCwyLjdjMy42LDEuMSw1LjcsMiw1LjcsNS4zQzQxLjgsNDMuNiw0MC4yLDQ1LjQsMzYuOCw0NS44eiIvPgoJPC9nPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjM1LjQiIHkxPSI2OC4yIiB4Mj0iMzUuNCIgeTI9IjU0LjQiLz4KCTxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9IjQwLjUsNjMuOCAzNS40LDY4LjYgMzAuMyw2My44IAkiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDcyIDcyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA3MiA3MjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtkaXNwbGF5Om5vbmU7fQoJLnN0MXtkaXNwbGF5OmlubGluZTt9Cgkuc3Qye2ZpbGw6bm9uZTtzdHJva2U6IzQ0RTQ5QjtzdHJva2Utd2lkdGg6MztzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qze2ZpbGw6IzFBNjFGMzt9Cgkuc3Q0e2ZpbGw6bm9uZTtzdHJva2U6I0ZGRkZGRjtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CjxnIGlkPSJMYXllcl8xIiBjbGFzcz0ic3QwIj4KCTxnIGlkPSJMYXllcl8xXzFfIiBjbGFzcz0ic3QxIj4KCTwvZz4KCTxnIGlkPSJMYXllcl8zIiBjbGFzcz0ic3QxIj4KCTwvZz4KPC9nPgo8ZyBpZD0iTGF5ZXJfM18xXyI+Cgk8Y2lyY2xlIGNsYXNzPSJzdDIiIGN4PSIzNi4yIiBjeT0iMzcuNyIgcj0iMjMuNCIvPgoJPHJlY3QgeD0iMjUuMyIgeT0iOS42IiBjbGFzcz0ic3QzIiB3aWR0aD0iMTAuOSIgaGVpZ2h0PSIxNC45Ii8+Cgk8cG9seWxpbmUgY2xhc3M9InN0MiIgcG9pbnRzPSIxOS4xLDE1IDI2LDE1LjUgMjYsMjIuNSAJIi8+CjwvZz4KPGcgaWQ9IkxheWVyXzIiPgoJPHBvbHlnb24gY2xhc3M9InN0NCIgcG9pbnRzPSIzOS4xLDI0LjIgMzcuNSwzNS4yIDQzLjEsMzUuMiAzMi45LDUxLjIgMzQuNiw0MCAyOC45LDQwIAkiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDcyIDcyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA3MiA3MjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtkaXNwbGF5Om5vbmU7fQoJLnN0MXtkaXNwbGF5OmlubGluZTt9Cgkuc3Qye2ZpbGw6bm9uZTtzdHJva2U6IzQ0RTQ5QjtzdHJva2Utd2lkdGg6MztzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qze2ZpbGw6IzFBNjFGMzt9Cgkuc3Q0e2ZpbGw6bm9uZTtzdHJva2U6I0ZGRkZGRjtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Q1e2ZpbGw6I0ZGRkZGRjt9Cjwvc3R5bGU+CjxnIGlkPSJMYXllcl8xIiBjbGFzcz0ic3QwIj4KCTxnIGlkPSJMYXllcl8xXzFfIiBjbGFzcz0ic3QxIj4KCTwvZz4KCTxnIGlkPSJMYXllcl8zIiBjbGFzcz0ic3QxIj4KCTwvZz4KPC9nPgo8ZyBpZD0iTGF5ZXJfM18xXyI+Cgk8Y2lyY2xlIGNsYXNzPSJzdDIiIGN4PSIzNi4yIiBjeT0iMzcuNyIgcj0iMjMuNCIvPgoJPHJlY3QgeD0iMjYiIHk9IjkuNiIgY2xhc3M9InN0MyIgd2lkdGg9IjEwIiBoZWlnaHQ9IjE0LjkiLz4KCTxwb2x5bGluZSBjbGFzcz0ic3QyIiBwb2ludHM9IjE5LjEsMTUgMjYsMTUuNSAyNiwyMi41IAkiLz4KCTxyZWN0IHg9IjM2IiB5PSI1My42IiBjbGFzcz0ic3QzIiB3aWR0aD0iMTAuOSIgaGVpZ2h0PSIxNC45Ii8+Cgk8cG9seWxpbmUgY2xhc3M9InN0MiIgcG9pbnRzPSI1Mi42LDYxIDQ1LjYsNjAuNSA0NS43LDUzLjYgCSIvPgoJPHJlY3QgeD0iMjcuNyIgeT0iMzQuNSIgY2xhc3M9InN0NCIgd2lkdGg9IjE2LjYiIGhlaWdodD0iMTIuMyIvPgoJPHBhdGggY2xhc3M9InN0NCIgZD0iTTMwLjgsMzQuNXYtMy45YzAsMCwwLjctMy45LDUuMi0zLjlzNS4xLDMuOSw1LjEsMy45djMuOSIvPgoJPGc+CgkJPHBhdGggY2xhc3M9InN0NSIgZD0iTTM1LjksMzguOWMwLjQsMCwwLjYsMC4zLDAuNiwwLjZzLTAuMywwLjYtMC42LDAuNnMtMC42LTAuMy0wLjYtMC42UzM1LjYsMzguOSwzNS45LDM4LjkgTTM1LjksMzcuOQoJCQljLTAuOSwwLTEuNiwwLjctMS42LDEuNnMwLjcsMS42LDEuNiwxLjZzMS42LTAuNywxLjYtMS42UzM2LjgsMzcuOSwzNS45LDM3LjlMMzUuOSwzNy45eiIvPgoJPC9nPgoJPGxpbmUgY2xhc3M9InN0NCIgeDE9IjM1LjkiIHkxPSI0MC41IiB4Mj0iMzUuOSIgeTI9IjQyLjciLz4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(64);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(8);
	
	var _grid = __webpack_require__(27);
	
	var _segment = __webpack_require__(50);
	
	var _theme = __webpack_require__(51);
	
	var _header = __webpack_require__(28);
	
	var _footer = __webpack_require__(48);
	
	var _wrapper = __webpack_require__(52);
	
	var _navbar = __webpack_require__(67);
	
	var _Hyperstate_WebIllustration = __webpack_require__(472);
	
	var _Hyperstate_WebIllustration2 = _interopRequireDefault(_Hyperstate_WebIllustration);
	
	var _Hyperstate_Economical = __webpack_require__(484);
	
	var _Hyperstate_Economical2 = _interopRequireDefault(_Hyperstate_Economical);
	
	var _Hyperstate_Efficient = __webpack_require__(485);
	
	var _Hyperstate_Efficient2 = _interopRequireDefault(_Hyperstate_Efficient);
	
	var _Hyperstate_Secure = __webpack_require__(486);
	
	var _Hyperstate_Secure2 = _interopRequireDefault(_Hyperstate_Secure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreblekeyPage = function TreblekeyPage(props) {
	    return _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: _theme.HyperstateTheme },
	        _react2.default.createElement(
	            _wrapper.Wrapper,
	            null,
	            _react2.default.createElement('img', { style: { position: 'absolute', right: '0' }, src: _Hyperstate_WebIllustration2.default, alt: '' }),
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Hyperstate' }),
	            _react2.default.createElement(
	                _segment.Segment,
	                { style: { height: 0, padding: 0, margin: 0, zIndex: 999 } },
	                _react2.default.createElement(
	                    _navbar.Navbar,
	                    null,
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#top' },
	                            'Hyperstate'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#why' },
	                        'WHY'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#tech' },
	                        'TECH'
	                    )
	                )
	            ),
	            _react2.default.createElement('div', { id: 'top' }),
	            _react2.default.createElement(
	                _segment.Segment,
	                { sheet: true, dark: true, noback: true },
	                _react2.default.createElement(
	                    _grid.Grid,
	                    { style: { padding: '3em 0 3em 0' } },
	                    _react2.default.createElement(_grid.Column, { span: '2' }),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '10' },
	                        _react2.default.createElement(
	                            _header.MajorHeader,
	                            { inverse: true },
	                            _react2.default.createElement(
	                                'h1',
	                                { style: { padding: '0,0,0,20', lineHeight: '100px', textAlign: 'left', letterSpacing: 4 } },
	                                'WHAT IS',
	                                _react2.default.createElement('br', null),
	                                'HYPERSTATE?',
	                                _react2.default.createElement('br', null)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { style: { lineHeight: '50px', letterSpacing: 1.5, paddingBottom: '40px', fontSize: '24' } },
	                            'Hyperstate is a system for generating royalty',
	                            _react2.default.createElement('br', null),
	                            'statements to multiple parties within long value',
	                            _react2.default.createElement('br', null),
	                            'chains, efficiently, and quickly.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { sheet: true, shadow: true },
	                _react2.default.createElement('div', { id: 'what', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                _header.Header,
	                                null,
	                                _react2.default.createElement(
	                                    'h1',
	                                    { style: { paddingTop: '100px', paddingBottom: '50px', letterSpacing: 3.5 } },
	                                    'WHAT DOES THAT MEAN?'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _header.Header,
	                                null,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { style: { fontWeight: '600', paddingBottom: '50px', letterSpacing: 1.2 } },
	                                    _react2.default.createElement(
	                                        _header.Accent,
	                                        null,
	                                        '[ Imagine you\'re an artist ]'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black', fontWeight: '0', letterSpacing: '1.2', lineHeight: '50px' } },
	                                'You, and other artists, have to wait for your label to provide you with an excel file or statement about all your streams and what they owe you. But they also have to wait to receive an xml or csv file from their distributor, and the distributor probably has to wait for a txt file from Apple music and Spotify. Maybe there was someone else in between, an aggregator, or another label partner. Each of these steps takes a month, maybe more, and each introduces room for error.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null),
	                                'What if the distributor could simply import the file from Spotify, and the labels, aggregators, distributors and you, the Artist, all get statements with all the fees already calculated, all at once, immediately.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                _header.Header,
	                                null,
	                                _react2.default.createElement(
	                                    'h4',
	                                    { style: { padding: '60px 0 150px 0', fontWeight: '600', letterSpacing: 1.2 } },
	                                    _react2.default.createElement(
	                                        _header.Accent,
	                                        null,
	                                        'That\'s Hyperstate.'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { dark: true, noback: true, sheet: true },
	                _react2.default.createElement('div', { id: 'why', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { style: { padding: '0 0 0 0.4em', letterSpacing: 4, paddingBottom: '50px' } },
	                                    'WHY?'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _header.Accent,
	                                null,
	                                _react2.default.createElement(
	                                    'ul',
	                                    { style: { listStyle: 'circle' } },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { color: 'white', fontSize: '24', letterSpacing: 1.5 } },
	                                            'Because nobody should have to wait 6 months from the time their music is played, to the time they get paid.'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _header.Accent,
	                                null,
	                                _react2.default.createElement(
	                                    'ul',
	                                    { style: { listStyle: 'circle' } },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { color: 'white', fontSize: '24', letterSpacing: 1.5 } },
	                                            'Because we shouldn\'t need to import and export multiple file types multiple times, just to get the same answer.'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _header.Accent,
	                                null,
	                                _react2.default.createElement(
	                                    'ul',
	                                    { style: { listStyle: 'circle' } },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            { style: { color: 'white', fontSize: '24', letterSpacing: 1.5, padding: '0 0 60px 0' } },
	                                            'Because there are too many mistakes, mismatches, and lost payments to artists.'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { centered: true, top: true, span: '4' },
	                            _react2.default.createElement('img', { src: _Hyperstate_Efficient2.default, style: { width: '100%', maxWidth: '200px' } }),
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'h2',
	                                    { style: { fontSize: '20', fontWeight: '600', letterSpacing: '2', textAlign: 'center' } },
	                                    'EFFICIENT'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { centered: true, top: true, span: '4' },
	                            _react2.default.createElement('img', { src: _Hyperstate_Economical2.default, style: { width: '100%', maxWidth: '200px' } }),
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'h2',
	                                    { style: { fontSize: '20', fontWeight: '600', letterSpacing: '2', textAlign: 'center' } },
	                                    'ECONOMICAL'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { centered: true, top: true, span: '4' },
	                            _react2.default.createElement('img', { src: _Hyperstate_Secure2.default, style: { width: '100%', maxWidth: '200px' } }),
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'h2',
	                                    { style: { fontSize: '20', fontWeight: '600', letterSpacing: '2', textAlign: 'center' } },
	                                    'SECURE'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { sheet: true, shadow: true },
	                _react2.default.createElement('div', { id: 'tech', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(
	                    _grid.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h1',
	                                { style: { padding: '100px 0 100px 0', letterSpacing: 3.5 } },
	                                'TECHNOLOGY'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h4',
	                                { style: { fontWeight: '600', padding: '0 0 20px 0', letterSpacing: 1.2 } },
	                                _react2.default.createElement(
	                                    _header.Accent,
	                                    null,
	                                    'Get Paid Faster'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            'p',
	                            { style: { color: 'black', letterSpacing: '1.2', lineHeight: '50px', padding: '0 0 100px 0' } },
	                            'Hyperstate is designed to process royalties in one step, no matter how many people are in between the artist and the listener, ensuring arists get paid faster and reducing costs for everyone involved.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h4',
	                                { style: { fontWeight: '600', padding: '0 0 20px 0', letterSpacing: 1.2 } },
	                                _react2.default.createElement(
	                                    _header.Accent,
	                                    null,
	                                    'Reduce Overhead Costs'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            'p',
	                            { style: { color: 'black', letterSpacing: '1.2', lineHeight: '50px', padding: '0 0 100px 0' } },
	                            'Hyperstate is built on Hyperledger fabric, a permissioned blockchain technology that allows us to build contractual royalty fees into a digital system, link these contracts together across the entire value chain, and maintain privacy and confidentiality for everyone at the same time.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _header.Header,
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            { style: { fontWeight: '600', padding: '0 0 20px 0', letterSpacing: 1.2 } },
	                            _react2.default.createElement(
	                                _header.Accent,
	                                null,
	                                'Private Transactions'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            'p',
	                            { style: { color: 'black', letterSpacing: '1.2', lineHeight: '50px', padding: '0 0 100px 0' } },
	                            'Because the system is decentralized, there is no central person or company that needs to be trusted to keep data private and secure, only the technology itself which anyone can check, test, and audit freely to ensure complete security.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { dark: true, noback: true, sheet: true },
	                _react2.default.createElement(
	                    _footer.Footer,
	                    { dark: true },
	                    _react2.default.createElement('div', null),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _header.Accent,
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'EXPLORE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { style: { listStyle: 'none' } },
	                            _react2.default.createElement(
	                                'li',
	                                { style: { fontSize: '18' } },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'http://www.membran.net' },
	                                    'membran.net'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { style: { fontSize: '18' } },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/' },
	                                    'membran labs'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { style: { fontSize: '18' } },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/treblekey' },
	                                    'treblekey'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { style: { fontSize: '18' } },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/harvest' },
	                                    'harvest'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { style: { fontSize: '18' } },
	                                _react2.default.createElement(
	                                    _header.Accent,
	                                    null,
	                                    'hyperstate'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _header.Accent,
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'CONTACT'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { style: { listStyle: 'none' } },
	                            _react2.default.createElement(
	                                'li',
	                                { style: { fontSize: '18' } },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'mailto:canada@membran.net' },
	                                    'email us'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = TreblekeyPage;
	
	/*
	
	<Img 
	  css={{ top: 0, left: 0, right: 0, zIndex: -1 }}
	  style={{ position: `absolute` }}
	  title='Header image'
	  alt='computer workstation'    
	  sizes={props.data.header.sizes}
	  className='background'
	/>

	*/

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hyperstate-js-12a0c0c95244490082e0.js